var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0673 55.9432L18.3332 43.6224C17.1598 42.2534 17.1598 40.2977 18.3332 38.9287C19.5066 37.7553 21.4623 37.7553 22.8313 38.9287L32.4142 49.0983L58.816 22.6965C59.9894 21.5231 61.9451 21.5231 63.1185 22.6965C64.2919 24.0655 64.2919 26.0211 63.1185 27.3901L34.5654 55.9432C33.392 57.3122 31.4363 57.3122 30.0673 55.9432Z",
    fill: "#40C706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.6ee6850811d488cc8943be0f17fd46ed.svg";
export { ForwardRef as ReactComponent };